import definedAbility from "@/ability";
import mixpanel from "mixpanel-browser";

export const GrooveChatScript = () => {
  if (process.env.VUE_APP_GROOVE_CHAT_ENABLED === "true") {
    if (!window.location.href.includes("preview")) {
      const grooveChatScript = document.createElement("script");
      grooveChatScript.innerHTML =
        '!function (e, t) { if (!e.groove) { var i = function (e, t) { return Array.prototype.slice.call(e, t) }, a = { widget: null, loadedWidgets: {}, classes: { Shim: null, Embeddable: function () { this._beforeLoadCallQueue = [], this.shim = null, this.finalized = !1; var e = function (e) { var t = i(arguments, 1); if (this.finalized) { if (!this[e]) throw new TypeError(e + "() is not a valid widget method"); this[e].apply(this, t) } else this._beforeLoadCallQueue.push([e, t]) }; this.initializeShim = function () { a.classes.Shim && (this.shim = new a.classes.Shim(this)) }, this.exec = e, this.init = function () { e.apply(this, ["init"].concat(i(arguments, 0))), this.initializeShim() }, this.onShimScriptLoad = this.initializeShim.bind(this), this.onload = void 0 } }, scriptLoader: { callbacks: {}, states: {}, load: function (e, i) { if ("pending" !== this.states[e]) { this.states[e] = "pending"; var a = t.createElement("script"); a.id = e, a.type = "text/javascript", a.async = !0, a.src = i; var s = this; a.addEventListener("load", (function () { s.states[e] = "completed", (s.callbacks[e] || []).forEach((function (e) { e() })) }), !1); var n = t.getElementsByTagName("script")[0]; n.parentNode.insertBefore(a, n) } }, addListener: function (e, t) { "completed" !== this.states[e] ? (this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t)) : t() } }, createEmbeddable: function () { var t = new a.classes.Embeddable; return e.Proxy ? new Proxy(t, { get: function (e, t) { return e instanceof a.classes.Embeddable ? Object.prototype.hasOwnProperty.call(e, t) || "onload" === t ? e[t] : function () { e.exec.apply(e, [t].concat(i(arguments, 0))) } : e[t] } }) : t }, createWidget: function () { var e = a.createEmbeddable(); return a.scriptLoader.load("groove-script", "https://b36d27f7-9426-46a3-9eed-e15bfee03651.widget.cluster.groovehq.com/api/loader"), a.scriptLoader.addListener("groove-iframe-shim-loader", e.onShimScriptLoad), e } }; e.groove = a } }(window, document);\n' +
        "      window.groove.widget = window.groove.createWidget();\n" +
        "      window.groove.widget.init('b36d27f7-9426-46a3-9eed-e15bfee03651', {});";
      document.head.appendChild(grooveChatScript);
    }
  }
};
export const ClarityScript = () => {
  if (process.env.NODE_ENV === "production") {
    if (!window.location.href.includes("preview")) {
      const clarityScript = document.createElement("script");

      if (definedAbility().can("use", "3rd party clarity script")) {
        clarityScript.innerHTML =
          "      (function (c, l, a, r, i, t, y) {\n" +
          "        c[a] = c[a] || function () {\n" +
          "          (c[a].q = c[a].q || []).push(arguments)\n" +
          "        };\n" +
          "        t = l.createElement(r);\n" +
          "        t.async = 1;\n" +
          '        t.src = "https://www.clarity.ms/tag/" + i;\n' +
          "        y = l.getElementsByTagName(r)[0];\n" +
          "        y.parentNode.insertBefore(t, y);\n" +
          '      })(window, document, "clarity", "script", "kk3xl88uea");';

        document.head.appendChild(clarityScript);
      } else if (definedAbility().can("use", "inulti clarity script")) {
        clarityScript.innerHTML = `(function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "gqhxzx6lvj");`;

        document.head.appendChild(clarityScript);
      }
    }
  }
};

export const DripScript = () => {
  if (process.env.VUE_APP_DRIP_DCS_ACCOUNT_ID && process.env.VUE_APP_DRIP_ENABLED === "true") {
    var _dcq = _dcq || [];
    var _dcs = _dcs || {};
    _dcs.account = process.env.VUE_APP_DRIP_DCS_ACCOUNT_ID;
    const dripScript = document.createElement("script");
    dripScript.innerHTML =
      "(function() {\n" +
      "            var dc = document.createElement('script');\n" +
      "            dc.type = 'text/javascript'; dc.async = true;\n" +
      "            dc.src = '//tag.getdrip.com/" +
      process.env.VUE_APP_DRIP_DCS_ACCOUNT_ID +
      ".js';\n" +
      "            var s = document.getElementsByTagName('script')[0];\n" +
      "            s.parentNode.insertBefore(dc, s);\n" +
      "          })();";
    document.head.appendChild(dripScript);
  }
};

export const GtmScript = () => {
  if (definedAbility().can("use", "google tag manager")) {
    const gtmScript = document.createElement("script");
    gtmScript.innerHTML =
      "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n" +
      "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n" +
      "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n" +
      "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n" +
      "})(window,document,'script','dataLayer','GTM-TKNR3V2M');";

    document.head.appendChild(gtmScript);

    const gtmNoScript = document.createElement("noscript");
    gtmNoScript.innerHTML =
      '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TKNR3V2M" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
    document.body.prepend(gtmNoScript);
  }
};

export const GoogleAdsScript = () => {
  const googleAdsScript = document.createElement("script");
  googleAdsScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-16455619013');
  `;

  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-16455619013";

  document.head.appendChild(gtagScript);
  document.head.appendChild(googleAdsScript);
};

let scriptsLoaded = false;
export const loadScripts = cookieValues => {
  if (scriptsLoaded) return;

  // if (cookieValues.marketing && cookieValues.statistical) {
  ClarityScript();
  // }

  // if (cookieValues.marketing && cookieValues.analytical) {
  DripScript();
  // }

  // if (cookieValues.marketing) {
  GoogleAdsScript();
  // }

  // if (cookieValues.functional) {
  GtmScript();
  // }

  if (process.env.VUE_APP_MIXPANEL_ENABLED === "true") {
    // if (cookieValues.analytical) {
    mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {}, "main");
    // }
  }

  scriptsLoaded = true;
};

export const loadGrooveChatScript = () => {
  GrooveChatScript();
};
